<template>
  <div :class="{'nav-open': $sidebar.showSidebar}">
    <notifications></notifications>
    <router-view></router-view>
  </div>
</template>

<script>
  import jwtToken from './helpers/jwt-token';
  
  import axios from 'axios'
  axios.interceptors.request.use(
    (config) => {
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      if (jwtToken.getToken()) {
        config.headers['Authorization'] = 'Bearer ' + jwtToken.getToken();
        config.headers['Accept'] = '*/*';
        config.headers['Access-Control-Allow-origin'] = '*';
        config.headers['Content-Type'] = 'application/json';
      }
      return config;
    },
    (error) => {
      console.error('Error en el interceptor:', error);
      return Promise.reject(error);
    }
  );
  axios.interceptors.response.use(
    response => response,
    error => {
      if (error.response && error.response.status === 401) {
          window.localStorage.removeItem('jwt_user');
          window.localStorage.removeItem('jwt_licencia');
          window.localStorage.removeItem('jwt_token');
          location.href = location.origin+'/login';
      }
      return Promise.reject(error);
    }
  );
  
  export default {}
</script>
<style lang="scss">
  .vue-notifyjs.notifications{
    .list-move {
      transition: transform 0.3s, opacity 0.4s;
    }
    .list-item {
      display: inline-block;
      margin-right: 10px;

    }
    .list-enter-active {
      transition: transform 0.2s ease-in, opacity 0.4s ease-in;
    }
    .list-leave-active {
      transition: transform 1s ease-out, opacity 0.4s ease-out;
    }

    .list-enter {
      opacity: 0;
      transform: scale(1.1);

    }
    .list-leave-to {
      opacity: 0;
      transform: scale(1.2, 0.7);
    }
  }
</style>
